import type { z } from 'zod';

import { currencyInput } from '@/_schemas/generic';

import { productAndServicesTemplateItemQuerySchema } from './products-and-services-template-item-query-schema';

export const productAndServicesTemplateItemFormSchema = productAndServicesTemplateItemQuerySchema
  .omit({
    product_id: true,
  })
  .extend({
    default_quantity: currencyInput.formSchema(),
    default_price: currencyInput.formSchema(),
  });

export type ProductAndServicesTemplateItemFormSchema = z.infer<typeof productAndServicesTemplateItemFormSchema>;
